

@if (imageUrl2()) {
    <img [src]="imageUrl" alt="Image" class="image-preview"/>
} @else {
    @if (error) {
        <div>{{ error }}</div>
    } @else {
        <div>Loading...</div>
    }
}